import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Card, Divider, Popover, Pagination} from "antd";
import { getApprovedAwardList } from "../../../../../redux/employeeaward/employeeAwardState";
import dayjs from "dayjs";
import { displayIcon } from "variables/icons";

const AwardeeDetails = ({ item }) => {

  const colorClass = item?.award_color_class?.toLowerCase();

  return (
    <Card className={`rounded-xl card-theme ${colorClass} w-full`}>
      <div className="flex flex-row items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="relative inline-block">
            <Avatar
              size={64}
              style={{
                background: "linear-gradient(to bottom right, #10b981, #8b5cf6)",
                border: "4px solid white",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}
            >
              {item?.employee_initials}
            </Avatar>

            <Popover
              content={item?.award_title}
              trigger="hover"
              placement="top"
              overlayClassName="reward-popover"
            >
              <div
                className={`absolute -right-1 -bottom-1 w-6 h-6 sm:w-8 sm:h-8 icon-style ${colorClass} shadow-lg border-2 border-white flex items-center justify-center`}
              >
                {displayIcon(item?.award_icon, "w-3 h-3 sm:w-4 sm:h-4 text-white")}
              </div>
            </Popover>
          </div>

          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <h4 className="flex flex-wrap items-center gap-2 font-semibold text-base title-text break-words">
              {item?.employee_name}
              {displayIcon("Trophy", "w-5 h-5 fill-yellow-500 text-yellow-500")}
            </h4>

            <p className="text-xs mb-2 muted-text">{item?.employee_position}</p>

            <span className={`status-indicator ${colorClass} text-xs`}>
              {item?.award_title}
            </span>
          </div>
        </div>

        <div
          className={`w-12 h-12 sm:w-16 sm:h-16 icon-style ${colorClass} shadow-lg flex items-center justify-center`}
        >
          {displayIcon(item?.award_icon, "w-6 h-6 sm:w-8 sm:h-8 text-white")}
        </div>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="space-y-2">
        <div className="flex items-center justify-between text-[13px]">
          <span className="muted-text">Award Month:</span>
          <span className="font-medium title-text">
            {item?.ema_issued_at
              ? dayjs(item.ema_issued_at).format("MMMM YYYY")
              : "-"}
          </span>
        </div>

        <div>
          <p className="mb-2 muted-text">Achievement:</p>
          <p className="text-[13px] title-text break-words leading-relaxed">{item?.ema_feedback}</p>
        </div>
        <div className="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-4 border border-emerald-200 dark:from-emerald-900 dark:to-purple-900 dark:border-emerald-700">
          <p className="text-[13px] text-center font-medium text-emerald-700 dark:text-emerald-200">
            🎉 Congratulations on your outstanding achievement! 🎉
          </p>
        </div>
      </div>
    </Card>
  );
};

const AvatarGrid = ({ }) => {
  
  const dispatch = useDispatch();
  const recordList = useSelector((state) => state.employeeAward.approvedAwardList?.items);
  const pagination = useSelector((state) => state.employeeAward.approvedAwardList?.pagination);
  const filters = useSelector((state) => state.employeeAward.approvedAwardList?.filters);

  const doSearch = (filters) => dispatch(getApprovedAwardList(filters));

  useEffect(() => {
    dispatch(getApprovedAwardList({paginate: pagination.per_page}));
  }, [dispatch, pagination.per_page]);

  return (
    <div>
      {recordList?.length === 0 ? (
        <div className="text-center py-8">
          {displayIcon("Trophy", "w-12 h-12 text-gray-300 mx-auto mb-3")}
          <p className="text-sm muted-text">No approved awards yet</p>
        </div>
      ) : (
        <div className="flex gap-4 flex-wrap">
          {recordList?.map((item) => (
            <AwardeeDetails key={item?.ema_id} item={item} />
          ))}
        </div>
      )}

      {pagination?.total > pagination?.per_page && (
        <div className="flex justify-end py-4">
          <Pagination
            current={pagination?.current_page}
            pageSize={pagination?.per_page}
            total={pagination?.total}
            showSizeChanger={false}
            onChange={(page) =>
              doSearch({
                ...filters,
                page,
                paginate: pagination?.per_page,
              })
            }
          />
        </div>
      )}
    </div>
  );
};

export default AvatarGrid;